module.exports = __webpack_public_path__ + "assets/img/alge_timing_logo.eacdf994.svg";